// let editPayment = import('./editPayment/index');

export default [
    {
        path: '/admin/payments-system',
        component: () => import('./index.vue'),
        children: [
            {
                path: 'edit-payment/:id',
                component: () => import('./editPayment/index.vue'),
                props: true
            },
            {
                path: 'add-payment/',
                component: () => import('./editPayment/index.vue'),
                props: true
            }
        ]
    },
]
